import { useMemo } from "react";
import { useSelector } from "react-redux";
import { isCaseManager } from "domain/User.model";

/**
 * Hook to determine if the current user is a case manager.
 *
 * @returns {boolean} - Returns true if the user is a case manager, false otherwise.
 */
export const useIsCaseManager = () => {
    const user = useSelector((state) => state.mainReducer.user);
    return useMemo(() => isCaseManager(user), [user]);
}
